import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import ModuleIcon, { Props } from '../_components/ModuleIcon';

const mapStateToProps = (store:Store, props:Props) => ({
	type: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'type']),
	thumbnail: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'thumbnail']) || "",
	color: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'color']) || "",
	sides: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'sides']),
	saturation: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'saturation']),
	hue: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'hue']),
	brightness: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'brightness']),
	contrast: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'contrast']),
});

export default connect(
	mapStateToProps,
	null,
	null,
	{ forwardRef: true }
)(ModuleIcon);